
function BackgroundTrianglify() {
    return (<img
        src="background.svg"
        alt="Punto Pagos"
        className="w-full h-full object-cover"
    />)
}

export { BackgroundTrianglify };